var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9542 26.9813H10.0328C6.15631 26.9813 3.57202 25.043 3.57202 20.5205V11.4755C3.57202 6.95299 6.15631 5.01477 10.0328 5.01477H22.9542C26.8307 5.01477 29.415 6.95299 29.415 11.4755V20.5205C29.415 25.043 26.8307 26.9813 22.9542 26.9813Z",
    stroke: "white",
    strokeWidth: 1.72286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.9542 12.1216L18.9098 15.3519C17.5788 16.4115 15.3951 16.4115 14.0642 15.3519L10.0327 12.1216",
    stroke: "white",
    strokeWidth: 1.72286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.f8d7ea02f00e5d893d7f68d9c51883d2.svg";
export { ForwardRef as ReactComponent };